import {z} from 'zod';

export const DocumentPreviewBasePageSchema = z.object({
  id: z.string(),
  url: z.string(),
  pageNumber: z.number(),
});

export type DocumentPreviewBasePage = z.infer<typeof DocumentPreviewBasePageSchema>;
